// Style import
import '../scss/style.scss';

// JS imports
import initAthletePopup from './components/athlete-popup.js';
import initFeedSlider from './components/feed-slider.js';
import initImageSlider from './components/image-slider.js';
import initBlogPagination from './components/blog-pagination.js';
import initFilters from './components/filters.js';
import initDropbox from './components/dropbox.js';
import initCampaignMap from './components/campaign-map.js';
import initTooltips from './components/tooltips.js'
import initInternationalRedirect from './components/international-redirect.js';
import initBlog from './components/blog.js'
import supporterSlider from './components/supporter-slider.js'
import sponsorSlider from './components/sponsor-slider.js'
import resourcesPopup from './components/resources-popup.js';
import './svelte-index';
import resourcesSlider from './components/resources-slider.js';
import athleteAllianceSlider from './components/athlete-alliance-slider.js';

window.addEventListener('load', function(event) {
  supporterSlider.init();
  sponsorSlider.init();
  resourcesSlider.init();
  resourcesPopup.init();
  athleteAllianceSlider.init();
});

jQuery(() => {
  initAthletePopup(jQuery);
  initFeedSlider(jQuery);
  initImageSlider(jQuery);
  initBlogPagination(jQuery);
  initFilters(jQuery);
  initDropbox(jQuery);
  initCampaignMap(jQuery);
  initTooltips(jQuery);
  initInternationalRedirect(jQuery);
  initBlog(jQuery);
})
